var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { createMuiTheme, responsiveFontSizes, } from "@material-ui/core/styles";
export var createLightTheme = function (options) {
    var theme = createMuiTheme(__assign(__assign({}, options), { palette: __assign(__assign({}, options.palette), { background: {
                paper: "#fff",
                default: "#fafafa",
            }, primary: {
                light: "#62cdff",
                main: "#009ce2",
                dark: "#006eb0",
                contrastText: "#000",
            }, secondary: {
                light: "#ff59bc",
                main: "#e7018c",
                dark: "#af005f",
                contrastText: "#000",
            }, 
            // secondary: {
            //   light: "#ffff65",
            //   main: "#ffe529",
            //   dark: "#c8b300",
            //   contrastText: "#000",
            // },
            error: {
                light: "#e57373",
                main: "#f44336",
                dark: "#d32f2f",
                contrastText: "#fff",
            }, text: {
                primary: "rgba(0, 0, 0, 0.87)",
                secondary: "rgba(0, 0, 0, 0.54)",
                disabled: "rgba(0, 0, 0, 0.38)",
                hint: "rgba(0, 0, 0, 0.38)",
            } }) }));
    return responsiveFontSizes(theme);
};
